<template>
  <div class="er002 mainWrap" v-loading.fullscreen.lock="fullscreenLoading">
    <el-container style="height: 100%; background-color: rgba(0, 0, 0, 0)">
      <!-- 左边导航栏 -->
      <el-aside style="width: auto">
        <leftNav msg="/ER002"></leftNav>
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
          <el-main>
            <div class="mainWrao">
              <div class="recordTitle">
                <h1>{{ $t("leftNav.navfiveteen") }}</h1>
                <div style="float: right; display: flex; align-items: center">
                  <label style="margin-right: 10px; font-size: 12px">{{
                    $t("StepCycleTime.labelTitle1")
                  }}</label>
                  <equipment
                    @change="getchange"
                    class="machinevue"
                    :machine="machineID[1]"
                  ></equipment>
                </div>
              </div>
              <div style="position: relative;">
                <!--蒙板-->
                <div class="mask" v-show="noMachine">
                  <p >{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</p>
                </div>
                <div class="tableWrap">
                  <div class="times">
                    <!-- 修改时间段部分开始 -->
                    <el-date-picker
                      :picker-options="pickerOptions"
                      @change="timeChange"
                      :clearable="false"
                      v-model="selectTime"
                      type="daterange"
                      range-separator="———"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                    <!-- 修改时间段部分结束 -->
                    <span class="machineID">{{ showMachineID }}</span>
                    <span class="range" v-show="timeArr.length !== 0"
                      >{{ timeArr[0] }} ~ {{ timeArr[1] }}</span>
                    <el-button
                      :disabled="disabled"
                      v-show="this.$store.state.authority.PageDownload.show"
                      icon="el-icon-download"
                      class="export"
                      @click="exportExcel()"
                      >{{ $t("ReloadingStatistics.export") }}</el-button
                    >
                  </div>
                  <div v-if="noMachineInFactory==true" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentInFactory')}}</div>
                  <!-- 表格 -->
                  <el-table
                    v-loading="tableLoading"
                    :data="tableData"
                    :header-cell-style="titleStyle"
                    :cell-style="cellStyle"
                    :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                    height="580"
                    style="width: 100%; margin-top: 20px"
                    v-else
                  >
                    <el-table-column width="175" fixed>
                      <template slot="header" slot-scope="scope">
                        <p class="w">{{ $t("er02.title1") }}</p>
                        <p class="w">{{ showMachineID }}</p>
                        <span class="w">{{ $t("er02.title2") }}</span>
                      </template>
                      <template slot-scope="scope">
                        <div style="text-align: center">
                          <p>
                            <span>{{ scope.row.code }}</span>
                          </p>
                          <p>
                            <span>{{ scope.row.event }}</span>
                          </p>
                          <p></p>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column width="108" fixed>
                      <template slot="header" slot-scope="scope">
                        <p></p>
                        <p></p>
                        <p class="w" v-show="tableTitle.tireInfoNum !== ''">
                          {{ tableTitle.tireInfoNum }}
                          {{ $t("ReloadingStatistics.tires") }}
                        </p>
                      </template>
                      <template>
                        <div style="text-align: center">
                          <p>{{ $t("er02.Frequency") }}</p>
                          <p>{{ $t("er02.Occurred") }}</p>
                          <p>{{ $t("er02.LostTime") }}</p>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column width="120" fixed>
                      <template slot="header" slot-scope="scope">
                        <p class="white">{{ $t("er02.title3") }}</p>
                        <p
                          v-show="tableTitle.statisticAllNum !== ''"
                          class="white"
                        >
                          {{ tableTitle.statisticAllNum }}
                          {{ $t("ReloadingStatistics.frequency") }}
                        </p>
                        <p
                          v-show="tableTitle.statisticAllTime !== ''"
                          class="white"
                        >
                          {{ tableTitle.statisticAllTime }}
                          {{ $t("ReloadingStatistics.minute") }}
                        </p>
                      </template>
                      <template slot-scope="scope">
                        <div style="text-align: right">
                          <p>
                            {{ scope.row.unit }}
                            {{ $t("ReloadingStatistics.frequency") }}
                          </p>
                          <p></p>
                          <p>
                            {{ scope.row.unitTime }}
                            {{ $t("ReloadingStatistics.minute") }}
                          </p>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :width="tableWidth">
                      <template slot="header" slot-scope="scope">
                        <ul class="hoursList">
                          <li
                            v-for="(item, index) in tableTitle.list"
                            :key="index"
                          >
                            <p>{{ item.hours }}</p>
                            <p>
                              {{ item.statisticNum }}
                              {{ $t("ReloadingStatistics.frequency") }}
                            </p>
                            <p>
                              {{ item.statisticTime }}
                              {{ $t("ReloadingStatistics.minute") }}
                            </p>
                          </li>
                        </ul>
                      </template>
                      <template slot-scope="scope">
                        <ul class="infoList">
                          <li
                            v-for="(item, index) in scope.row.list"
                            :class="{ err: item.color }"
                            :key="index"
                          >
                            <p>{{ item.statisticNum }}</p>
                            <p>{{ item.firstTime }}</p>
                            <p v-show="item.durationTime !== ''">
                              {{ item.durationTime }}
                              {{ $t("ReloadingStatistics.second") }}
                            </p>
                          </li>
                        </ul>
                      </template>
                    </el-table-column>
                  </el-table>

                  <!-- 下面的时间 -->
                  <div class="times" style="margin-top: 20px">
                  <el-date-picker
                      :picker-options="pickerOptions"
                      @change="timeChange"
                      :clearable="false"
                      v-model="selectTime"
                      type="daterange"
                      range-separator="———"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                    <span class="machineID">{{ showMachineID }}</span>
                    <span class="range" v-show="timeArr.length !== 0"
                      >{{ timeArr[0] }} ~ {{ timeArr[1] }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { formatDate } from "../assets/js/date.js";
import leftNav from "@/components/nav.vue";
import equipment from "@/components/Equipment.vue";
export default {
  name: "ER002",
  components: {
    leftNav,
    equipment,
  },
  data() {
    return {
      //  模拟数据
      options: [],
      // 选中的机械id
      machineID: [],
      fullscreenLoading: false,
      tableLoading: false,
      // 表格数据
      tableData: [],
      tableTitle: {
        tireInfoNum: "",
        statisticAllTime: "",
        statisticAllNum: "",
        list: [],
      },
      // 时间
      selectTime: [], //修改时间段选择
      startTime: null, //修改的
      nowTime: null,
      // 当前机械的班组开始时间
      workTime: "",
      // 按钮边显示的时间范围
      timeArr: [],
      // 时间选择器禁用
      pickerOptions: {
        //修改开始
        onPick: ({ minDate }) => {
          this.startTime = minDate.getTime();
        },
        disabledDate: (time) => {
          if (this.startTime) {
            return (
              time.getTime() < this.startTime - 8.64e7 * 6 ||
              time.getTime() > this.startTime + 8.64e7 * 6 ||
              time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
        //修改结束
      },
      showMachineID: "",
      disabled: true,
      // 2420宽
      tableWidth: 20000,
      noMachine:false,
      //该工厂是否配置机器
      noMachineInFactory:false
    };
  },
  mounted() {
    this.selectTime = [
      new Date(Date.now()),
      new Date(Date.now()),
    ];
    //修改结束
    this.$store.commit("authority", this.$route.path);
    this.getManiceList();
    //  this.getdate()
  },
  computed: {
    islangChange() {
      return this.$store.state.lang;
    },
  },
  watch: {
    islangChange(curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload();
      }
    },
  },
  methods: {
    // 切换设备
    getchange(value) {
      this.selectTime = [
        new Date(Date.now()),
        new Date(Date.now()),
      ];
      this.startTime=''
      this.machineID[1] = value;
      this.getdate();
    },
    // 获取车间列表
    getManiceList() {
      let _this = this;
      this.axios({
        method: "get",
        url: "/url/selectChooseManice",
        params: {
          language: _this.$store.state.lang,
        },
      }).then(function (res) {
        if (res.data.success === "true") {
           if(res.data.options !==undefined && res.data.options.length > 0 ){
              _this.noMachine=false
            if (localStorage.getItem("isMarketAccount") === "1") {
              _this.$store.commit("marketAccount", res.data.options);
            }
            _this.options = res.data.options;
           }else{
              _this.noMachine=true
            }
        } else {
          _this.$message.error("Machine list loading failed");
        }
      });
    },
    // 获取当前日期和早班开始时间
    getdate() {
      this.fullscreenLoading = true;
      let _this = this;
      this.axios({
        method: "post",
        url: "/url/getReloadingTime",
        params: {
          machineId: _this.machineID[1],
          language: _this.$store.state.lang,
        },
      })
        .then(function (res) {
          if (res.data.success === "true") {
            // _this.selectTime = res.data.date;
            _this.nowTime = res.data.date;
            _this.workTime = res.data.time;
            _this.timeRange();
          } else {
            _this.$message.error(res.data.msg);
          }
        })
        .then(function () {
          _this.getTableData();
        });
    },
    // 按钮边显示的时间范围
    timeRange() {
      let startTime = `${formatDate(new Date(this.selectTime[0]), "yyyy/MM/dd")}${
        this.workTime
      }`;
      let endTime = `${formatDate(
        new Date(new Date(this.selectTime[1]).getTime() + 86400000),
        "yyyy/MM/dd"
      )}${this.workTime}`;
      this.timeArr = [startTime, endTime];
    },
    timeChange() {
      let _this = this;
      new Promise(function (resolve) {
        _this.timeRange();
        resolve();
      }).then(function () {
        if( _this.machineID[1]){
          _this.getTableData();
        }
      });
    },
    // 获取表格数据
    getTableData() {
      this.tableWidth = 20000;
      this.tableLoading = true;
      let _this = this;
      this.axios({
        method: "post",
        url: "/url/getSingleEquipmentReloadingAnalysis",
        params: {
          machineId: _this.machineID[1],
          startTime: _this.timeArr[0],
          endTime: _this.timeArr[1],
          language: _this.$store.state.lang,
        },
      }).then(function (res) {
        if (res.data.success === "true") {
          if(('data' in res.data && 'data2' in res.data) === false){
            _this.noMachineInFactory=true;
            _this.fullscreenLoading = false;
            _this.tableLoading = false;
            _this.disabled = false;
            _this.showMachineID =
              res.data.machine.equipmentName +
              "(" +
              res.data.machine.nameEn +
              ")";
            return
          }
          _this.noMachineInFactory=false
          _this.tableWidth = 100 * res.data.data2.list.length + 40;
          if (_this.tableWidth == 100 * res.data.data2.list.length + 40) {
            _this.tableResult = res;
            _this.tableData = res.data.data;
            _this.tableTitle = res.data.data2;
            _this.showMachineID =
              res.data.machine.equipmentName +
              "(" +
              res.data.machine.nameEn +
              ")";
            // _this.$parent.reload();
            _this.$nextTick(function () {
              _this.isShowTable = true;
            });
          }
        } else {
          _this.$message.error(res.data.msg);
        }
        _this.fullscreenLoading = false;
        _this.tableLoading = false;
        _this.disabled = false;
      });
    },
    tableRowClassName({ row }) {
      if (row.color === true) {
        return "warning-row";
      }
      return "";
    },
    //导出
    exportExcel() {
      let signTime = new Date().getTime();
      this.$store.commit("nowsign", signTime);
      if (this.machineID[1] && this.timeArr[0] && this.timeArr[1]) {
        let urlData =
          "?machineId=" +
          this.machineID[1] +
          "&startTime=" +
          this.timeArr[0] +
          "&endTime=" +
          this.timeArr[1] +
          "&language=" +
          this.$store.state.lang +
          "&sign=" +
          this.$store.state.sign +
          "&auth_Code=" +
          this.$store.state.authCode +
          "&sign_time=" +
          signTime +
          "&route=" +
          this.$store.state.newroute +
          "&factory_id=" +
          this.$store.state.factoryId;
        window.open("/url/excelExportReloadingAnalysis" + urlData, "_blank");
      }
    },
    titleStyle() {
      return "background-color:#305496;";
    },
    cellStyle({ columnIndex }) {
      if (columnIndex === 0) {
        return "background-color:#bdd7ee;";
      } else if (columnIndex === 1) {
        return "background-color:#bdd7ee;border-left:1px solid #ffffff;";
      }
    },
  },
};
</script>
<style scoped>
.er002 {
  min-width: 1365px !important;
}
.mainWrao {
  height: 100%;
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 30px;
}
.recordTitle {
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1 {
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.mask{
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 107%;
  z-index: 10;
  box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.14);
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-size: 30px;
  word-wrap: break-word;
  padding-top: 10%;
  box-sizing: border-box;
}
.tableWrap {
  box-sizing: border-box;
  margin: 20px 15px;
}
.times .picker {
  margin-right: 15px;
}
.times button {
  padding: 12px;
}
.times .range {
  font-size: 14px;
  margin-left: 25px;
}
.times .export {
  float: right;
  width: 100px;
}
.times .machineID {
  font-weight: bold;
  font-size: 14px;
  margin-left: 25px;
}
.hoursList,
.infoList {
  overflow: hidden;
}
.hoursList li {
  width: 100px;
  float: left;
  font-weight: bold;
  text-align: right;
  color: #fff;
}
.infoList li {
  width: 100px;
  float: left;
  text-align: right;
}
.infoList .err p {
  color: red;
}
.tableWrap .el-table p {
  min-height: 23px;
  padding: 0px 6px;
}
.white {
  text-align: right;
  color: #fff;
  font-weight: bold;
}
.w {
  color: #fff;
  font-weight: bold;
}
.noMachineTitle{
  color:#909399;
  line-height: 100px;
  text-align: center;
}
</style>
